import { create } from 'zustand';

const useStore = create((set, get) => ({
  // Settings loaded flag - prevents saving during initial load
  settingsLoaded: false,
  setSettingsLoaded: (loaded) => set({ settingsLoaded: loaded }),

  // User Settings (loaded from server)
  gridConfig: { cols: 2, rows: 2 },
  setGridConfig: (config) => {
    set({ gridConfig: config });
    // Only save to server if settings have been loaded (prevents save during initial load)
    if (get().settingsLoaded) {
      fetch('/api/user/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ gridConfig: config })
      }).catch(err => console.error('Failed to save grid config:', err));
    }
  },
  
  selectedLayout: 'all',
  setSelectedLayout: (layout) => {
    set({ selectedLayout: layout });
    if (get().settingsLoaded) {
      fetch('/api/user/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ selectedLayout: layout })
      }).catch(err => console.error('Failed to save layout:', err));
    }
  },
  
  sidebarCollapsed: false,
  setSidebarCollapsed: (collapsed) => {
    set({ sidebarCollapsed: collapsed });
    if (get().settingsLoaded) {
      fetch('/api/user/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ sidebarCollapsed: collapsed })
      }).catch(err => console.error('Failed to save sidebar state:', err));
    }
  },
  
  theme: 'dark',
  setTheme: (theme) => {
    set({ theme });
    if (get().settingsLoaded) {
      fetch('/api/user/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ theme })
      }).catch(err => console.error('Failed to save theme:', err));
    }
  },
  
  cameraOrder: [],
  setCameraOrder: (order) => {
    set({ cameraOrder: order });
    if (get().settingsLoaded) {
      fetch('/api/user/settings', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ cameraOrder: order })
      }).catch(err => console.error('Failed to save camera order:', err));
    }
  },
  
  // Global config (managed via AdminSettings, read-only for non-admins)
  waveConfig: {
    host: '',
    port: 7001,
    username: 'admin',
    password: '',
    useHttps: true
  },
  setWaveConfig: (config) => set({ waveConfig: { ...get().waveConfig, ...config } }),
  
  // Cameras
  cameras: [],
  setCameras: (cameras) => set({ cameras }),
  
  // Layouts
  layouts: [],
  setLayouts: (layouts) => set({ layouts }),
  
  // Go2RTC URL (from global config)
  go2rtcUrl: '',
  setGo2rtcUrl: (url) => set({ go2rtcUrl: url }),
  
  // Clear tenant-specific data (called when switching tenants)
  clearTenantData: () => set({
    cameras: [],
    layouts: [],
    waveConfig: {
      host: '',
      port: 7001,
      username: 'admin',
      password: '',
      useHttps: true
    },
    go2rtcUrl: '',
    cameraOrder: []
  }),
  // Milestone thumbnail cache - captured frames from WebRTC stream
  milestoneThumbnails: {},
  setMilestoneThumbnail: (cameraId, dataUrl) => set(state => ({
    milestoneThumbnails: { ...state.milestoneThumbnails, [cameraId]: dataUrl }
  })),
}));

export default useStore;
